<template>
  <footer id="footer" class="footer">
    <div class="footer__container container">
      <div class="footer__logo-wrapper">
        <a href="#main" class="footer__logo-link">
          <svg
            class="footer__ktech-logo"
            viewBox="0 0 105 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="K-Tech"
          >
            <path
              d="M69.0641 9.18866V5.74911H58.1854V13.8124H55.4508L56.8879 17.2519H58.1854V25.3152H69.0641V21.8757H61.6705V17.2519H65.5812V13.8124H61.6705V9.18866H69.0641Z"
              fill="#fff"
            />
            <path
              d="M100.716 5.74911V13.8124H95.0617V5.74911H91.5789V13.8124H88.8444L90.2791 17.2519H91.5789V25.3152H95.0617V17.2519H100.716V25.3152H104.199V5.74911H100.716Z"
              fill="#fff"
            />
            <path
              d="M55.4531 5.74689V9.19095H50.9954V25.3152H47.5126V9.19095H43.5812V5.74689H55.4531Z"
              fill="#fff"
            />
            <path
              d="M79.714 21.8734C76.1625 21.8734 73.2883 19.035 73.2883 15.5345C73.2883 12.0339 76.1625 9.18869 79.714 9.18869C81.7368 9.18869 83.5355 10.113 84.7117 11.5525H89.1968C87.6247 7.9096 83.9725 5.35593 79.714 5.35593C74.0206 5.35593 69.4096 9.91186 69.4096 15.5322C69.4096 21.1525 74.0229 25.7017 79.714 25.7017C83.9725 25.7017 87.6293 23.1503 89.1968 19.5051H84.7117C83.5355 20.9469 81.7368 21.8689 79.714 21.8689V21.8734Z"
              fill="#fff"
            />
            <path
              d="M37.5767 18.1085C38.9997 18.1085 40.1533 16.9692 40.1533 15.5638C40.1533 14.1585 38.9997 13.0192 37.5767 13.0192C36.1536 13.0192 35 14.1585 35 15.5638C35 16.9692 36.1536 18.1085 37.5767 18.1085Z"
              fill="#fff"
            />
            <path
              d="M32.2082 30L21.0229 28.391L15.7689 15.8034V28.391H5.254V15.8034H0V3.21356H10.5103V15.8034L15.7689 3.21356L27.6201 0L21.0229 15.8034H26.2792L32.2082 30Z"
              fill="#00DBFF"
            />
          </svg>
        </a>
        <a
          href="https://kgforum.kz/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer__logo-link"
        >
          <img
            :src="require('@/assets/icons/kgf_2025_c.png')"
            alt="KGF"
            class="footer__kgf-logo"
          />
        </a>
      </div>

      <nav class="footer__nav">
        <a
          href="#program"
          class="footer__nav-link"
          @click="anchor($event, 'program')"
          >{{
          $t("2026.footer.nav.program")
        }}</a
        >
        <a
          href="#nomination"
          class="footer__nav-link"
          @click="anchor($event, 'nomination')"
          >{{
          $t("nomination.title")
        }}</a
        >
        <a href="#cio" class="footer__nav-link" @click="anchor($event, 'cio')">{{
          "cio"
        }}</a>
        <a href="#menti" class="footer__nav-link" @click="anchor($event, 'menti')">{{
          $t("headers.mentoring")
        }}</a>
        <a href="#partners" class="footer__nav-link" @click="anchor($event, 'partners')">{{
          $t("2026.footer.nav.partners")
        }}</a>
        <a href="#speakers" class="footer__nav-link" @click="anchor($event, 'speakers')">{{
          $t("2026.footer.nav.speakers")
        }}</a>
        <a href="#reviews" class="footer__nav-link" @click="anchor($event, 'reviews')">{{
          $t("2026.footer.nav.reviews")
        }}</a>
        <a href="#footer" class="footer__nav-link" @click="anchor($event, 'footer')">{{
          $t("2026.footer.nav.contacts")
        }}</a>
      </nav>

      <div class="footer__title">{{ $t("2026.footer.our_networks") }}</div>

      <div class="footer__socials-wrapper">
        <div class="footer__socials">
          <a
            class="footer__social-button"
            href="https://www.facebook.com/groups/KazakhstanGrowthForum/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img
              :src="require('@/assets/icons/facebook-bm-logo.svg')"
              alt="facebook"
            />
          </a>
          <a
            class="footer__social-button"
            href="https://www.youtube.com/@KazakhstanGrowthForum"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Youtube"
          >
            <img
              :src="require('@/assets/icons/youtube-bm-logo.svg')"
              alt="youtube"
            />
          </a>
          <a
            class="footer__social-button"
            href="https://t.me/kgfnewscentras"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Telegram"
          >
            <img
              :src="require('@/assets/icons/telegram-bm-logo.svg')"
              alt="telegram"
            />
          </a>
          <a
            class="footer__social-button"
            href="https://www.instagram.com/ktech_summit/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img
              :src="require('@/assets/icons/instagram-bm-logo.svg')"
              alt="instagram"
            />
          </a>
          <a
            class="footer__social-button"
            href="https://api.whatsapp.com/message/KKFG6GDZ4FN3E1?autoload=1&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            @click="trackWhatsAppClick"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
              />
            </svg>
          </a>
          <a
            class="footer__social-button"
            href="mailto:marketing@kgforum.kz"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Email"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              />
            </svg>
          </a>
        </div>
        <div class="footer__decor-line"></div>
      </div>

      <div class="footer__policy-wrapper">
        <div class="footer__policy-block">
          <div class="footer__legal">{{ $t("2026.footer.legal") }}</div>
          <a
            class="footer__policy"
            href="/privacy-policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Политика конфиденциальности KGF</a
          >
        </div>
        <div class="footer__contacts-block">
          <div>
            <div class="footer__subtitle">
              {{ $t("2026.footer.questions") }}
            </div>
            <div class="footer__contact-row">
              <svg
                class="footer__contact-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                />
              </svg>
              <a
                href="https://wa.me/77014288490"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__contact"
                @click="trackWhatsAppClick"
                >+ 7 (701) 428-84-90</a
              >
            </div>
          </div>
          <div>
            <div class="footer__subtitle">
              {{ $t("2026.footer.contact_us") }}
            </div>
            <a href="mailto:marketing@kgforum.kz" class="footer__contact"
              >marketing@kgforum.kz</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { reachGoal } from "@/utils/yandexMetrika";
import { smoothScrollTo } from "@/utils/smoothScroll";

export default {
  name: "TheFooter",
  methods: {
    anchor(event, blockID) {
      event.preventDefault();
      const targetElement = document.getElementById(blockID);

      if (targetElement) {
        smoothScrollTo(targetElement.offsetTop - 100);
      }
    },
    trackWhatsAppClick() {
      reachGoal("click_whatsapp");
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  min-height: 488px;
  background: #221f20;
  background: linear-gradient(
    180deg,
    rgba(34, 31, 32, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  color: white;
  font-family: "Geologica", sans-serif;
  @media (max-width: 480px) {
    min-height: 546px;
  }

  &__container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    padding-top: 50px;
    padding-bottom: 50px;
    box-sizing: border-box;
    @media (max-width: 768px) {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    @media (max-width: 480px) {
      gap: 20px;
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }

  &__logo-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    gap: clamp(28px, 5vw + 24px, 72px);
    flex-wrap: wrap;
    margin-bottom: clamp(16px, 2vw + 12px, 32px);
    @media (max-width: 768px) {
      justify-content: space-between;
    }
  }

  &__logo-link {
    display: block;
    line-height: 0;
  }

  &__ktech-logo {
    display: block;
    height: clamp(28px, 3vw + 20px, 44px);
    width: auto;
  }

  &__kgf-logo {
    height: clamp(44px, 5vw + 36px, 72px);
    width: auto;
    object-fit: contain;
  }

  &__nav {
    display: flex;
    flex-wrap: wrap;
    max-width: 500px;
    gap: 10px;
    align-items: center;
    justify-content: center;
    font-size: 14px;

    &-link {
      color: white;
      text-decoration: none;
      text-transform: uppercase;
      &:hover {
        color: white;
        opacity: 0.85;
      }
    }

    @media screen and (max-width: 1100px) {
      font-size: 12px;
    }
    @media screen and (max-width: 940px) {
      font-size: 10px;
      gap: 5px;
    }
    @media (max-width: 480px) {
      max-width: 100%;
    }
  }

  &__title {
    font-family: "Geologica", sans-serif;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
  }

  &__socials-wrapper {
    position: relative;
    width: 100%;
    height: 40px;
  }

  &__socials {
    max-width: 508px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    @media (max-width: 480px) {
      width: 100%;
      max-width: 100%;
      padding: 0 10px;
    }
  }

  &__social-button {
    width: 72px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #662e56;
    border-radius: 20px;
    border: 1px solid #91d63c;
    color: #fff;
    img,
    svg {
      width: 20px;
      height: 20px;
    }
    img {
      filter: brightness(0) invert(1);
    }
    &:hover {
      opacity: 0.9;
    }
    @media (max-width: 480px) {
      width: 40px;
      height: 40px;
      img {
        width: 19px;
        height: 19px;
      }
    }
    @media (max-width: 390px) {
      width: 30px;
      height: 30px;
      img {
        width: 15px;
        height: 15px;
      }
    }
  }

  &__decor-line {
    height: 2px;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background: rgba(255, 255, 255, 0.3);
  }

  &__policy-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    @media (max-width: 600px) {
      flex-direction: column-reverse;
    }
  }

  &__policy-block {
    max-width: 350px;
    @media (max-width: 1100px) {
      max-width: 260px;
    }
    @media (max-width: 600px) {
      max-width: 100%;
    }
  }

  &__contacts-block {
    display: flex;
    flex-direction: row;
    gap: 30px;
    @media (max-width: 1100px) {
      flex-direction: column;
      text-align: right;
      gap: 10px;
    }
    @media (max-width: 600px) {
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 0;
    }
    @media (max-width: 550px) {
      flex-direction: column;
      font-size: 10px;
      text-align: left;
    }
  }

  &__legal {
    font-size: 10px;
    font-weight: 300;
    line-height: 1.4;
    margin-bottom: 10px;
  }

  &__policy {
    font-weight: 700;
    text-decoration: underline;
    font-size: 12px;
    color: white;
    &:hover {
      color: white;
      opacity: 0.9;
    }
    @media (max-width: 480px) {
      margin-top: 10px;
    }
  }

  &__subtitle {
    font-weight: 700;
    font-size: 18px;
    color: #00b4bc;
    margin-bottom: 4px;
    @media (max-width: 480px) {
      font-size: 12px;
    }
  }

  &__contact {
    font-weight: 700;
    font-size: 20px;
    color: #ffffff;
    text-decoration: none;
    &:hover {
      color: #ffffff;
      opacity: 0.9;
    }
    @media (max-width: 480px) {
      font-size: 10px;
    }
  }

  &__contact-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  &__contact-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #fff;
    @media (max-width: 480px) {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
